import { render } from "./ListeDevoirs.vue?vue&type=template&id=a412d2b2&scoped=true&ts=true"
import script from "./ListeDevoirs.vue?vue&type=script&lang=ts"
export * from "./ListeDevoirs.vue?vue&type=script&lang=ts"

import "./ListeDevoirs.vue?vue&type=style&index=0&id=a412d2b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a412d2b2"]])

export default __exports__